import { PublicContactUs } from "./PublicContactUs";

export const ContactUs = () => {
  return <PublicContactUs />;
};
